/**
 * Created by user on 2019/6/26.
 */
import { IOptionsDoSegment } from './types';

export const defaultOptionsDoSegment: IOptionsDoSegment = {};
